"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserServiceContractOrder = exports.UserServiceContractOrderDetails = exports.UserServiceContractOrderReasonEnum = void 0;
var lodash_1 = require("lodash");
var helpers_1 = require("../../helpers");
var properties = ['id', 'user_service_contract_id', 'account_id', 'status', 'details', 'expire_at', 'created_at', 'updated_at', 'deleted_at'];
var dateProperties = ['expire_at', 'created_at', 'updated_at', 'deleted_at'];
var UserServiceContractOrderReasonEnum;
(function (UserServiceContractOrderReasonEnum) {
  UserServiceContractOrderReasonEnum[UserServiceContractOrderReasonEnum["signup"] = 1] = "signup";
  UserServiceContractOrderReasonEnum[UserServiceContractOrderReasonEnum["prolong"] = 2] = "prolong";
})(UserServiceContractOrderReasonEnum = exports.UserServiceContractOrderReasonEnum || (exports.UserServiceContractOrderReasonEnum = {}));
/** Детали заказа на оплату контракта на услугу или продления контракта на услугу */
var UserServiceContractOrderDetails = /** @class */function () {
  function UserServiceContractOrderDetails(values) {
    (0, lodash_1.assign)(this, (0, lodash_1.pick)(values, ['reason', 'meeting_id', 'billing_processor', 'billing_order_id', 'billing_payment_id']));
    this.meeting_id = this.meeting_id || [];
  }
  return UserServiceContractOrderDetails;
}();
exports.UserServiceContractOrderDetails = UserServiceContractOrderDetails;
/** Заказ на оплату контракта на услугу или продления контракта на услугу */
var UserServiceContractOrder = /** @class */function () {
  function UserServiceContractOrder(values) {
    (0, lodash_1.assign)(this, (0, lodash_1.pick)(values, properties));
    (0, helpers_1.assignDates)(this, values, dateProperties);
    this.details = new UserServiceContractOrderDetails(values === null || values === void 0 ? void 0 : values.details);
  }
  return UserServiceContractOrder;
}();
exports.UserServiceContractOrder = UserServiceContractOrder;
